import { render, staticRenderFns } from "./AlertaConfigForm.vue?vue&type=template&id=507b0ec5&scoped=true&"
import script from "./AlertaConfigForm.vue?vue&type=script&lang=ts&"
export * from "./AlertaConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertaConfigForm.vue?vue&type=style&index=0&id=507b0ec5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b0ec5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('507b0ec5', component.options)
    } else {
      api.reload('507b0ec5', component.options)
    }
    module.hot.accept("./AlertaConfigForm.vue?vue&type=template&id=507b0ec5&scoped=true&", function () {
      api.rerender('507b0ec5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/ConfigurarAlertas/AlertaConfigForm.vue"
export default component.exports